import React, { useState } from "react";
import { Button, Form, Input, Modal, Upload } from "antd";

import Swal from "sweetalert2";
import { BaseURL } from "../../../constants/enum/baseURL.emum";
import NewsService from "../../../services/news.service";

const CreateNews = () => {
  const [visible, setVisible] = useState(false);
  const [showImage, setShowImage] = useState("");
  const handleCancel = () => {
    setVisible(false);
  };
  const [form] = Form.useForm();
  const showModal = () => {
    setVisible(true);
  };

  const normFile = (e: any) => {
    // console.log("upload file:", e);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  const propsUploadNews = {
    naem: "file",
    action: `${BaseURL.BASE_URL}/upload/news`,
    onChange: (info: any) => {
      // console.log(info.fileList[0].response);

      if (info.fileList[0].response !== undefined) {
        setShowImage(info.fileList[0].response.filename);
        // console.log(info.fileList[0].response.filename);
      }

      return info;
    },
  };

  const onFinish = async (values: any) => {
    // console.log(values);
    //image อยู่ที่นี่นะ values.upload[0].response.filename,
    const { title, discription, url, image } = values;

    await NewsService.createNews({
      title,
      discription,
      url,
      image: image[0].response.filename,
    }).then(() => {
      // console.log("สำเร็จ");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "บันทึกสำเร็จ",
        showConfirmButton: false,
        timer: 1500,
      }).then(() => {
        handleCancel();
        window.location.reload();
      });
    });
  };

  return (
    <>
      <button onClick={showModal} className="btn btn-secondary">
        <i className="bi bi-folder-plus"></i> เพิ่มข่าวใหม่
      </button>
      <Modal
        visible={visible}
        title="ตั้งค่ารายวิชาที่ต้องส่งเอกสาร"
        onCancel={handleCancel}
        footer={[
          <button
            type="submit"
            className="btn btn-primary"
            onClick={form.submit}
          >
            บันทึก
          </button>,
          <button
            type="reset"
            className="btn btn-warning ms-1"
            onClick={() => {
              form.resetFields();
              setShowImage("");
            }}
          >
            รีเซ็ต
          </button>,

          <button
            type="button"
            className="btn btn-danger ms-1"
            onClick={handleCancel}
          >
            Close
          </button>,
        ]}
      >
        <Form
          name="dynamic_form_nest_item"
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
          form={form}
          initialValues={{ title: "", discription: "", url: "" }}
        >
          <Form.Item
            name={"title"}
            label="หัวข้อข่าว"
            rules={[
              {
                required: true,
                message: "กรุณาระบุหัวข้อข่าวด้วยครับ",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={"discription"}
            label="รายละเอียด"
            rules={[
              {
                required: true,
                message: "กรุณาระบุรายละเอียดข่าวด้วยครับ",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={"url"}
            label="ลิงค์ข่าว"
            rules={[
              {
                type: "url",
                message: "ระบุเป็นลิงค์เท่านั้น",
              },
            ]}
          >
            <Input />
          </Form.Item>
          {showImage && (
            <div>
              <img
                className="img-fluid"
                width={`100%`}
                src={`${BaseURL.BASE_URL}/upload/news/${showImage}`}
              />
            </div>
          )}

          <Form.Item
            name="image"
            label="ภาพข่าว"
            valuePropName="fileList"
            getValueFromEvent={normFile}
            rules={[{ required: true, message: "upload ภาพข่าวด้วยครับ!" }]}
          >
            <Upload {...propsUploadNews} maxCount={1}>
              <Button>Click to upload</Button>
            </Upload>
          </Form.Item>
          <p className="text-muted">
            อัพโหลดได้เฉพาะรูปภาพเท่านั้น โดยมีขนาดแนะนำคือ 1280x720px
          </p>
        </Form>
      </Modal>
    </>
  );
};

export default CreateNews;
